function formatSubscriberCount(count: string | null | undefined): string {
    if (!count || count === '0') return '非公開';
    const num = parseInt(count, 10);
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + '万';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + '00';
    }
    return num.toString();
  }

  export function formatDuration(duration: string | number | null | undefined): string {
    if (!duration) return '計算中';
    
    // 数値の場合（秒）は時分秒に変換
    if (typeof duration === 'number') {
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = duration % 60;
        
        if (hours > 0) {
            return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } else {
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        }
    }

    // 文字列の場合（PT1H30M15S形式）
    const match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
    if (!match) return '配信予定';
    
    const hours = parseInt(match[1]?.slice(0, -1) || '0');
    const minutes = parseInt(match[2]?.slice(0, -1) || '0');
    const seconds = parseInt(match[3]?.slice(0, -1) || '0');
    
    if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    } else {
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
}